export function sanitizeNumericInput(
	value: string,
	maxDecimals: number,
): string {
	let sanitized = value.replace(/[^0-9.]/g, "");
	// Allow only one decimal point
	const parts = sanitized.split(".");
	if (parts.length > 2) {
		sanitized = `${parts[0]}.${parts.slice(1).join("")}`;
	}
	// Limit decimal places
	if (parts.length === 2 && parts[1].length > maxDecimals) {
		sanitized = `${parts[0]}.${parts[1].slice(0, maxDecimals)}`;
	}
	return sanitized;
}
